import { node } from 'prop-types'
import { Outlet, useLocation } from 'react-router-dom'
import { Header, Segment } from 'semantic-ui-react'
import SecondaryMenu from '../../components/SecondaryMenu'
import Layout from '../Layout'
import './Physics.scss'

function Physics() {
  const location = useLocation()
  return (
    <Layout>
      <div className='physics_header'>
        <Header as='h1'>Physics</Header>
        <Header as='h3' id='physics_header_description'>
          Explore solar physics and space weather
        </Header>
      </div>
      <div className='physics_body'>
        <div className='left_panel'>
          <SecondaryMenu
            items={[
              {
                name: 'Heliophysics',
                link: 'Heliophysics',
                icon: 'note',
              },
              {
                name: 'Space weather',
                link: 'spaceWeather',
                icon: 'sun',
              },
              {
                name: 'About F10.7 and F30 indices',
                link: 'aboutfindex',
                icon: 'lineChart',
              },
            ]}
            activeItem={location.pathname.split('/')[2]}
          />
        </div>
        <Segment className='right_panel'>
          <Outlet />
        </Segment>
      </div>
    </Layout>
  )
}

Physics.propTypes = {
  children: node,
}

export default Physics
